import { MapGroupId } from "../../types";
import img from "../../mapImages/InterchangeMainNew.webp";

const mapData = {
  groupId: MapGroupId.Interchange,
  groupName: {
    en: "Interchange",
    ru: "Развязка",
  },
  title: {
    en: "Main (New)",
    ru: "Главная (Новая)",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
